const data = {
  en: {
    header: {
      appName: 'Global Games',
      linkAbout: 'About Qlik',
      linkViz: 'Back to viz',
    },
    viz: {
      title: 'Medals per country',
    },
    filters: {
      Sport: 'Sport',
      Geography: 'Geography',
      animate: 'Animate',
      year: 'Year',
    },
    results: {
      showLess: 'Show less',
      showMore: 'Show more',
      allTimeTitle: 'All-Time Medal Table',
    },
    about: {
      title: 'About Qlik',
      subtitle: 'Accelerate business value with data - on our cloud or any cloud',
      text: 'Turn raw data into remarkable outcomes with end-to-end, multi-cloud data integration and analytics solutions. Close the gaps between data, insights, and action.',
      linkText: 'Learn more',
      howTitle: 'How we built Global Games webapp',
      howP1: 'This web app was built utilizing Qlik open source software including nebula.js, picasso.js, and enigma.js, in addition to other JavaScript libraries like React and d3.js. The Dorling cartogram (the “bubble chart” of medals by country) is a Qlik Sense visualization extension built with nebula.js, which enables you to build visualization extensions and embed visualizations.',
      howP2: 'And the timeline, dropdowns, animation buttons, and medal-type checkboxes are React components that use enigma.js to communicate with the Qlik Associative Engine. Check out the resources below to get started embedding visualizations, creating your own visualization extensions, and integrating Qlik Sense into your own web apps!',
      resourcesTitle: 'Resources',
      resourcesColumns: [
        {
          tag: 'Datasheet',
          title: 'Qlik API',
          text: 'Read how our APIs can help you build, extend and combine Qlik with other technologies.',
          linkText: 'Download Now',
          linkUrl: 'https://www.qlik.com/us/-/media/files/resource-library/global-us/direct/datasheets/ds-qlik-sense-apis-en.pdf',
        },
        {
          tag: 'Datasheet',
          title: 'Qlik Analytics Platform',
          text: 'Read how Qlik Analytics Platform can help you build, embed and integrate visual analytics.',
          linkText: 'Download Now',
          linkUrl: 'https://www.qlik.com/us/-/media/files/resource-library/global-us/direct/datasheets/ds-qlik-analytics-platform-en.pdf',
        },
        {
          tag: 'Learn',
          title: 'Qlik Developer Portal',
          text: 'Qlik\'s public APIs, Qlik\'s Associative Engine, developer documentation, tutorials, and much more.',
          linkText: 'Learn  More',
          linkUrl: 'https://qlik.dev/',
        },
      ],
    },
    footer: {
      title1: 'Company',
      column1link1: 'About Qlik',
      column1link2: 'Press Room',
      column1link3: 'Trust & Security',
      column1link4: 'Accessibility',
      column1link5: 'Privacy',
      column1link6: 'Careers',
      column1link7: 'Global Offices',
      column1link8: 'Contact Sales',
      title2: 'Resources',
      column2link1: 'Resource Library',
      column2link2: 'Qlik Partners',
      column2link3: 'Free Trials',
      column2link4: 'Compare Qlik',
      column2link5: 'Glossary',
      column2link6: 'Training',
      column2link7: 'Support',
      title3: 'Legal',
      column3link1: 'Legal Policies',
      column3link2: 'Trademarks',
      column3link3: 'Terms of Use',
      column3link4: 'Legal Agreements',
      column3link5: 'Product Terms',
      copyright: 'All Rights Reserved',
    },
  },
  jp: {
    header: {
      appName: 'グローバルゲーム',
      linkAbout: 'Qlik について',
      linkViz: 'Viz に戻る',
    },
    viz: {
      title: '国別メダル獲得数の推移',
    },
    filters: {
      Sport: 'スポーツ',
      Geography: '地理情報',
      animate: 'アニメーション',
      year: '年',
    },
    results: {
      showLess: '表示件数を減らす',
      showMore: '表示件数を増やす',
      allTimeTitle: '歴代メダル一覧',
    },
    about: {
      title: 'Qlik について',
      subtitle: 'Qlik または他のクラウドを問わず、データでビジネス価値を加速',
      text: 'エンドツーエンドの複数クラウドのデータ統合およびデータアナリティクスソリューションで生データから優れた成果を生み出し、データ、インサイト、アクション間のギャップを解消します。',
      linkText: '詳細を見る',
      howTitle: 'グローバルゲームの Web アプリ構築方法',
      howP1: '本 Webアプリは、React や d3.js などの JavaScript ライブラリや、nebula.js、picasso.js、enigma.js といった Qlik のオープンソースソフトウェアを利用して構築されています。Dorling Cartogram（国別のメダルの数を表す「バブルチャート」）は、nebula.js で構築した Qlik Sense のビジュアライゼーションエクステンションです。nebula.js で、ビジュアライゼーションエクステンションの構築や埋め込みが可能です。',
      howP2: 'また、タイムライン、ドロップダウンメニュー、アニメーションボタン、メダル型チェックボックスは、Qlik の連想エンジンとの通信に enigma.js を使用した React コンポーネントです。 以下のリソースを参照して、ビジュアライゼーションの埋め込みや独自のビジュアライゼーションエクステンションの作成、Qlik Sense の Web アプリへの統合を試してみてください。',
      resourcesTitle: 'リソース',
      resourcesColumns: [
        {
          tag: 'データシート',
          title: 'Qlik API',
          text: 'Qlik の API が、Qlik と他のテクノロジーを組み合わせて構築、拡張をサポートする方法をご確認ください。い。',
          linkText: '今すぐダウンロード',
          linkUrl: 'https://www.qlik.com/us/-/media/files/resource-library/global-us/direct/datasheets/ds-qlik-sense-apis-en.pdf',
        },
        {
          tag: 'データシート',
          title: 'Qlik アナリティクスプラットフォーム',
          text: 'Qlik のアナリティクスプラットフォームが、ビジュアルアナリティクスの構築、埋め込みと統合をサポートする方法をご確認ください。',
          linkText: '今すぐダウンロード',
          linkUrl: 'https://www.qlik.com/us/-/media/files/resource-library/global-us/direct/datasheets/ds-qlik-analytics-platform-en.pdf',
        },
        {
          tag: '学ぶ',
          title: 'Qlik 開発者向けサイト',
          text: 'Qlik のパブリック API、Qlik の連想エンジン、開発者向けの資料やチュートリアルをご紹介しています。',
          linkText: '詳細を見る',
          linkUrl: 'https://qlik.dev/',
        },
      ],
    },
    footer: {
      title1: '会社概要',
      column1link1: 'Qlik について',
      column1link2: 'プレスルーム',
      column1link3: '信頼性とセキュリティ',
      column1link4: 'アクセスの利便性',
      column1link5: 'プライバシー',
      column1link6: '採用情報',
      column1link7: 'グローバルオフィス',
      column1link8: '営業部門に連絡',
      title2: 'リソース',
      column2link1: 'リソースライブラリ',
      column2link2: 'Qlik パートナー',
      column2link3: '無料トライアル',
      column2link4: 'Qlik との比較',
      column2link5: '用語集',
      column2link6: 'トレーニング',
      column2link7: 'サポート',
      title3: '法務',
      column3link1: '法務ポリシー',
      column3link2: '商標',
      column3link3: '利用規約',
      column3link4: '法的合意事項',
      column3link5: '製品規約',
      copyright: 'All Rights Reserved',
    },
  },
};

export default data;
